class Block {
  constructor(block) {
    this.el = $(block);
  }
}

class TopBanner {
  constructor(document = window.document) {
    this.blocks = document.querySelectorAll('[data-block="top-banner"]');

    if (0 !== this.blocks.length) {
      this.blocks.forEach(block => {
        new Block(block);
      });
    }
  }
}

new TopBanner();